module.exports = __webpack_public_path__ + "media/images/calendarcheck_icon_inactive-2df4d816.svg";